import React from "react";

import { SelectAsync } from "components";

const SelectAsyncForDomain = ({ input, loadOptions, findOption, ...props }) => {
	const handleChange = option => {
		const value = option ? option.value : "";
		input.onChange(value);
	};

	const handleBlur = () => {
		input.onBlur(input.value);
	};

	return (
		<SelectAsync
			{...props}
			value={findOption(input.value)}
			onChange={handleChange}
			onBlur={handleBlur}
			loadOptions={loadOptions}
			placeholder="Please Select"
			isSearchable={false}
			isClearable={true}
		/>
	);
};

export default SelectAsyncForDomain;
